module.exports = __webpack_public_path__ + "img/chapter_5.37911d50.webp";